const Roles = {
  NONE: "none",
  SPEAKER: "speaker",
  ATTENDEE: "attendee",
};

export default Roles;
